/**
 * Initialize loaders for videos within a container.
 * Shows the message's internal .g-chatform-message-content-loader 
 * if the video is not yet ready.
 */
export function initVideoLoaders(container, loaderType = null, revealOnReady = true) {
    const $container = (container instanceof jQuery) ? container : $(container);

    // Find all message containers that have videos
    const messagesWithVideos = $container.find('.g-chatform-message').addBack('.g-chatform-message').filter(function () {
        return $(this).find('video').length > 0;
    });

    messagesWithVideos.each(function () {
        const message = $(this);
        const loader = message.find('.g-chatform-message-content-loader');
        const content = message.find('.g-chatform-message-content-inner');
        const video = message.find('video')[0];

        if (!video || !loader.length || !content.length) return;

        const onReady = () => {
            loader.hide();
            if (revealOnReady) {
                content.fadeIn(400);
            }
            video.removeEventListener('loadeddata', onReady);
            video.removeEventListener('canplay', onReady);
            video.removeEventListener('canplaythrough', onReady);
            video.removeEventListener('error', onReady);
        };

        // If already ready, just make sure it's shown (if allowed) and return
        if (video.readyState >= 2) {
            loader.hide();
            if (revealOnReady) {
                content.show();
            }
            return;
        }

        // Otherwise, show loader and hide content
        const loaderStyle = loaderType ? `style-${loaderType}` : (message.hasClass('is-new-message') ? 'style-dots' : 'style-spinner');
        loader.addClass(loaderStyle).removeClass(loaderStyle === 'style-dots' ? 'style-spinner' : 'style-dots').show();
        
        if (revealOnReady) {
            content.hide();
        }

        video.addEventListener('loadeddata', onReady);
        video.addEventListener('canplay', onReady);
        video.addEventListener('canplaythrough', onReady);
        video.addEventListener('error', onReady);

        // Ensure browser starts loading it
        if (typeof video.load === 'function' && video.readyState === 0) {
            video.load();
        }
    });
}
